/** @format */
import Modal from '../modal/modal.component';
import { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import {
  selectpairingModelParameters,
  selectPairingModelCrewCount,
  selectPairingModelLoading,
} from '../../redux/pairing-model/pairing-model.selectors';
import {
  setPairingModelParameters,
  setPairingModelCrewCount,
  setPairingModelLoading,
} from '../../redux/pairing-model/pairing-model.actions';

import { motion } from 'framer-motion';
import dayjs from 'dayjs';

const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#b71c1c',
    },
    secondary: {
      main: '#e0e0e0',
    },
    warning: {
      main: '#ff9100',
    },
  },
});

const PairingModelParameterInputComponent = () => {
  const dispatch = useDispatch();
  let parameters = useSelector(selectpairingModelParameters);
  let { start_date, end_date } = parameters;

  let [modalOpen, setModalOpen] = useState(false);

  let crew_count = useSelector(selectPairingModelCrewCount);
  let loading = useSelector(selectPairingModelLoading);

  const handleLoadingToggle = useCallback(() => {
    dispatch(setPairingModelLoading(!loading));
  }, [dispatch, loading]);

  const handleParamterChange = useCallback(
    (event) => {
      const { id, value } = event.target;
      dispatch(setPairingModelParameters({ [id]: value }));
    },
    [dispatch]
  );

  const handleCrewCountChange = useCallback(
    (event) => {
      const { id, value } = event.target;
      dispatch(setPairingModelCrewCount({ [id]: value }));
    },
    [dispatch]
  );

  return (
    <ThemeProvider theme={theme}>
      <Container
        component={motion.div}
        sx={{
          bgcolor: 'secondary.main',
          borderRadius: '10px',
          p: '2%',
          m: '2%',
          width: 'auto',
        }}
      >
        {modalOpen && (
          <Modal
            loading={loading}
            modalOpen={modalOpen}
            handleClose={() => {
              setModalOpen(false);
              handleLoadingToggle();
            }}
            text="Running Pairing Model"
            type="dropIn"
            variant="loadingModal"
            messageType="loading"
          />
        )}
        <h3>Pairing Model Parameter Input</h3>
        {Object.keys(parameters)
          .filter((key) => key !== 'start_date' && key !== 'end_date')
          .map((key) => {
            return (
              <FormControl key={key} sx={{ m: 1, width: '25ch' }}>
                <TextField
                  label=""
                  id={key}
                  value={parameters[key]}
                  onChange={handleParamterChange}
                  sx={{ m: 1, width: '25ch' }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">{key} =</InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            );
          })}

        <FormControl sx={{ m: 1, width: '25ch' }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">start_date: </InputAdornment>
                ),
              }}
              value={dayjs(start_date || new Date())}
              onChange={(newValue) => {
                console.log(newValue);
                dispatch(
                  setPairingModelParameters({
                    start_date: newValue.format('YYYY-MM-DD'),
                  })
                );
              }}
              renderInput={(params) => (
                <TextField sx={{ m: 1, width: '25ch' }} {...params} />
              )}
              //   onChange={(newValue) => setValue(newValue)}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl sx={{ m: 1, width: '25ch' }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">end_date: </InputAdornment>
                ),
              }}
              value={dayjs(end_date || new Date())}
              onChange={(newValue) => {
                console.log(newValue);
                dispatch(
                  setPairingModelParameters({
                    end_date: newValue.format('YYYY-MM-DD'),
                  })
                );
              }}
              renderInput={(params) => (
                <TextField sx={{ m: 1, width: '25ch' }} {...params} />
              )}
              //   onChange={(newValue) => setValue(newValue)}
            />
          </LocalizationProvider>
        </FormControl>
        <h3>Crew Count</h3>
        {Object.keys(crew_count).map((key) => {
          return (
            <FormControl key={key} sx={{ m: 1, width: '25ch' }}>
              <TextField
                label=""
                id={key}
                value={crew_count[key]}
                onChange={handleCrewCountChange}
                sx={{ m: 1, width: '25ch' }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">{key} =</InputAdornment>
                  ),
                }}
              />
            </FormControl>
          );
        })}
        <FormControl
          sx={{
            m: 1,
            width: '100%',

            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            component={motion.button}
            whileHover={{
              scale: 1.2,
              backgroundColor: '#b71c1c',
              color: '#e0e0e0',
              border: '1px solid #e0e0e0',
            }}
            whileTap={{ scale: 1.1 }}
            sx={{
              m: 1,
              width: '50ch',
              height: '50px',
              borderRadius: '10px',
              border: '1px solid #000',
            }}
            onClick={() => {
              setModalOpen(true);
              handleLoadingToggle();
            }}
          >
            RUN
          </Box>
        </FormControl>
      </Container>
    </ThemeProvider>
  );
};

export default PairingModelParameterInputComponent;
